import {ActionTypes} from '../types/actionTypes';
import {Action} from '../typescript/actionTypes';

export function getReleaseNotes(): Action {
    return {type: ActionTypes.GET_RELEASE_NOTES_REQUESTED, payload: ''};
}
